<template>
  <NavBar />
  <main class="faq-page">
    <div class="container faq-container">
      <header class="faq-header">
        <span class="eyebrow">YARDIM MERKEZİ</span>
        <h1>Sıkça sorulan sorular</h1>
        <p>Eğitim yolculuğunuzda merak ettiklerinizin cevapları burada.</p>
        <div class="faq-search">
          <i class="bi bi-search" aria-hidden="true"></i>
          <label for="faq-search" class="visually-hidden">Sorular ve cevaplar içinde ara</label>
          <input id="faq-search" ref="searchInput" v-model="searchQuery" type="search" placeholder="Bir soru veya konu arayın…" aria-controls="faq-results" @input="openQuestion = null">
          <button v-if="searchQuery" type="button" aria-label="Aramayı temizle" @click="searchQuery = ''; $refs.searchInput.focus()"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
        </div>
        <p class="search-hint">Örneğin: ders erteleme, Zoom, eğitim koçu</p>
      </header>
      <div class="faq-layout">
        <nav class="faq-categories" aria-label="Soru kategorileri">
          <p class="category-label">KATEGORİLER</p>
          <button v-for="cat in categories" :key="cat.id" type="button" class="category-button" :class="{ active: activeCategory === cat.id && !searchQuery.trim() }" :aria-pressed="activeCategory === cat.id && !searchQuery.trim()" @click="selectCategory(cat.id)">
            <i :class="cat.icon" aria-hidden="true"></i><span>{{ cat.title }}</span>
            <span class="category-count">{{ faqItems.filter(item => item.category === cat.id).length }}</span>
          </button>
        </nav>
        <section id="faq-results" aria-labelledby="results-title">
          <div class="results-header">
            <h2 id="results-title">{{ searchQuery.trim() ? 'Arama sonuçları' : categories.find(cat => cat.id === activeCategory).title }}</h2>
            <span role="status" aria-live="polite">{{ filteredFaq.length }} soru</span>
          </div>
          <p v-if="searchQuery.trim()" class="search-summary">“{{ searchQuery.trim() }}” için bulunan sorular</p>
          <div v-if="filteredFaq.length" class="faq-list">
            <article v-for="item in filteredFaq" :key="item.id" class="faq-item" :class="{ open: openQuestion === item.id }">
              <h3><button :id="'question-' + item.id" type="button" class="faq-question" :aria-expanded="openQuestion === item.id" :aria-controls="'answer-' + item.id" @click="openQuestion = openQuestion === item.id ? null : item.id">
                <span>{{ item.question }}</span><i :class="openQuestion === item.id ? 'bi bi-dash-lg' : 'bi bi-plus-lg'" aria-hidden="true"></i>
              </button></h3>
              <div v-show="openQuestion === item.id" :id="'answer-' + item.id" class="faq-answer" role="region" :aria-labelledby="'question-' + item.id" v-html="item.answer"></div>
            </article>
          </div>
          <div v-else class="faq-empty">
            <i class="bi bi-search" aria-hidden="true"></i>
            <h3>Eşleşen bir soru bulamadık</h3>
            <p>Farklı bir kelimeyle tekrar aramayı deneyin.</p>
            <button type="button" @click="searchQuery = ''; $refs.searchInput.focus()">Aramayı temizle</button>
          </div>
          <p class="faq-help">Başka bir sorunuz mu var? Eğitim koçunuza hafta içi 09.00 – 18.30 saatleri arasında ulaşabilirsiniz.</p>
        </section>
      </div>
    </div>
  </main>
  <FooterInPage />
</template>
<script>
import NavBar from '@/components/Shared/NavBar.vue'
import FooterInPage from '@/components/Shared/FooterInPage.vue'

export default {
  name: 'FaqPage',
  components: {
    NavBar,
    FooterInPage,
  },
  data() {
    return {
      searchQuery: '',
      activeCategory: 'general',
      openQuestion: null,
      categories: [
        { id: 'general', title: 'Genel Bilgiler', icon: 'bi bi-info-circle' },
        { id: 'lessons', title: 'Dersler & Eğitmenler', icon: 'bi bi-mortarboard' },
        { id: 'operations', title: 'Ders Yönetimi', icon: 'bi bi-calendar-event' }
      ],
      faqItems: [
        {
          id: 1,
          category: 'general',
          question: 'Eğitim koçumuza hangi saat aralığında ulaşabilirim?',
          answer: 'Eğitim koçlarımız hafta içi <strong>09.00 – 18.30</strong> saatleri arasında aktif olarak hizmet vermektedir. Ders saatiniz veya talebiniz mesai saatleri dışında gerçekleşiyorsa, eğitim koçunuza WhatsApp üzerinden mesaj iletebilirsiniz. İletmiş olduğunuz mesajlar, mesai saatleri içerisinde incelenerek tarafımızca en kısa sürede dönüş sağlanacaktır.'
        },
        {
          id: 2,
          category: 'lessons',
          question: 'Ders kaydı almak kurumun mu yoksa öğrencinin mi sorumluluğundadır?',
          answer: 'Ders kayıtlarının alınması <strong>öğrencinin sorumluluğundadır</strong>. Bu nedenle öğrencilerimizin, tekrar izleme ve ders takibi açısından kendi kayıtlarını almaları önemle tavsiye edilmektedir. Lengedu, kurum içi kalite ölçümleme ve eğitim denetimi amacıyla bazı ders kayıtlarını sınırlı süreyle saklayabilmektedir. Ancak bu kayıtlar düzenli öğrenci erişimine açık olmayabilir. Bu sebeple derslerinizi tekrar edebilmek ve eğitim sürecinizi daha verimli takip edebilmek adına, ders esnasında kendi kayıtlarınızı almanız önerilmektedir.'
        },
        {
          id: 3,
          category: 'lessons',
          question: 'Ders kaydı işlemini nasıl gerçekleştirebilirim?',
          answer: 'Derslerinizi Zoom uygulaması üzerinden kolayca kaydedebilirsiniz. Ders esnasında Zoom ekranında bulunan “Kaydet (Record)” butonuna tıklayarak kayıt işlemini başlatabilirsiniz. Kayıt alınabilmesi için eğitmeninizin onay vermesi gerekmektedir. Ders kayıt özelliği yalnızca bilgisayar üzerinden katılım sağlandığında aktif olarak kullanılabilmektedir. Mobil cihazlarda kayıt özelliği desteklenmeyebilir. Kayıt altına alınan dersleriniz, bilgisayarınıza yerel dosya olarak kaydedilir. Ders sonrasında Zoom uygulaması içerisinde veya bilgisayarınızdaki “İndirilenler / Downloads” klasöründen kayıt dosyalarınıza ulaşabilirsiniz.'
        },
        {
          id: 4,
          category: 'lessons',
          question: 'Zoom’da ders kaydı seçeneğini göremiyorsam bunun nedeni ne olabilir?',
          answer: 'Zoom’da “Kaydet (Record)” seçeneğini göremiyorsanız bunun birkaç farklı nedeni olabilir:<br><ul><li>Zoom uygulamanız güncel olmayabilir.</li><li>Derse tarayıcı üzerinden veya misafir kullanıcı olarak katılıyor olabilirsiniz.</li><li>Bilgisayarınıza Zoom uygulaması yüklü olmayabilir.</li><li>Eğitmen tarafından henüz kayıt izni verilmemiş olabilir.</li></ul><br>Bu sorunu çözebilmek için aşağıdaki adımları uygulamanız önerilir:<br>Zoom uygulamasını bilgisayarınıza indirip kurunuz. Uygulamanın güncel versiyonunu kullandığınızdan emin olunuz. Derse, misafir olarak değil kendi Zoom hesabınızla giriş yapınız. Ders başladıktan sonra eğitmeninizden kayıt izni talep ediniz.'
        },
        {
          id: 5,
          category: 'operations',
          question: 'Dersimi nasıl ve ne zaman erteleyebilirim?',
          answer: 'Dersinizi, planlanan ders saatinizden <strong>minimum 2 saat önce</strong> olmak kaydıyla öğrenci panelinizde yer alan “Ders Programı” bölümünden kolayca erteleyebilirsiniz. Ertelemek istediğiniz tarihin üzerine tıklayıp onay vermeniz yeterlidir. Erteleme işlemi sonrasında eğitim programınız toplu olarak ileri kaydırılır. Yani ertelenen dersiniz, programınızın sonuna eklenerek eğitim sürecinizde herhangi bir hak kaybı yaşanmaz.'
        },
        {
          id: 6,
          category: 'operations',
          question: 'Ders erteleme hakkı sınırlı mıdır? Ders erteleme işlemini kim gerçekleştirir?',
          answer: 'Evet, her eğitim paketinin kendine özel belirlenmiş bir ders erteleme hakkı bulunmaktadır. Kullanabileceğiniz erteleme hakkı, kayıt olduğunuz eğitim programına göre değişiklik gösterebilir. Ders erteleme işlemleri <strong>yalnızca öğrenci tarafından</strong> gerçekleştirilebilmektedir. Erteleme işleminin yapılabilmesi için, planlanan ders saatine minimum 2 saat kala öğrenci paneliniz üzerinden işlem yapılması gerekmektedir. Belirtilen süre içerisinde gerçekleştirilen erteleme işlemlerinde dersiniz program sonunda yeniden planlanır ve herhangi bir ders hakkı kaybı yaşanmaz. Bu işlem sonradan ekleme şeklinde değil toplu olarak ders kaydırılması şeklinde gerçekleşir.'
        },
        {
          id: 7,
          category: 'operations',
          question: 'Ders dondurma işlemini nasıl yapabilirim?',
          answer: 'Ders dondurma işlemleri eğitim koçunuz tarafından gerçekleştirilmektedir. Program sürenize göre sahip olduğunuz dondurma hakları şu şekildedir:<br><ul><li>6 aylık programlarda: maksimum 2 ay</li><li>12 aylık programlarda: maksimum 4 ay</li></ul><br>Dondurma hakkınızı tek seferde kullanabilirsiniz ancak isterseniz tamamını isterseniz de bir kısmını aktif edebilirsiniz. Örneğin; Hakkınız 4 ay ama sadece 1 ay dondurmak istediniz ve yani hakkınızı 1 ay olarak kullandınız gibi.'
        },
        {
          id: 8,
          category: 'general',
          question: "Lengedu nasıl çalışıyor?",
          answer: "Lengedu, gerçek bir İngilizce öğretmeniyle birebir online derslere katıldığınız; seviyenize özel eğitim takvimi, konuşma üniteleri, öğrenci portalı ve eğitim koçu desteği sunan online İngilizce eğitim sistemidir."
        },
        {
          id: 9,
          category: 'lessons',
          question: "Dersler birebir mi?",
          answer: "Evet. Canlı derslere öğretmeninizle birebir katılırsınız. Ders süresinin tamamı sizin konuşma pratiğinize ve ihtiyaçlarınıza ayrılır."
        },
        {
          id: 10,
          category: 'general',
          question: "İngilizce seviyem çok düşükse başlayabilir miyim?",
          answer: "Evet. Programlar A1 başlangıç seviyesinden C2 ileri seviyeye kadar mevcut seviyenize göre planlanabilir."
        },
        {
          id: 11,
          category: 'general',
          question: "İngilizce seviyemi nasıl öğrenebilirim?",
          answer: "Ücretsiz seviye tespiti görüşmesinde mevcut seviyeniz ve konuşma ihtiyaçlarınız belirlenir."
        },
        {
          id: 12,
          category: 'lessons',
          question: "Eğitmenler Türkçe biliyor mu?",
          answer: "Evet. Türkçe bilen profesyonel İngilizce öğretmenleriyle çalışırsınız; gerekli durumlarda Türkçe açıklama yapılabilir."
        },
        {
          id: 13,
          category: 'lessons',
          question: "Eğitmenim sabit mi, değiştirebilir miyim?",
          answer: "Amaç sabit öğretmenle düzenli ilerlemenizdir. İhtiyaç duyduğunuzda eğitim koçunuz üzerinden değişiklik talep edebilirsiniz."
        },
        {
          id: 14,
          category: 'lessons',
          question: "Dersler görüntülü olmak zorunda mı?",
          answer: "Hayır. Derslerinize görüntülü veya yalnızca sesli şekilde katılabilirsiniz."
        },
        {
          id: 15,
          category: 'lessons',
          question: "Hangi saatler arasında eğitim alabilirim?",
          answer: "Birebir dersler hafta içi 09.00–24.00 saatleri arasında öğretmen takvimine göre planlanabilir."
        },
        {
          id: 16,
          category: 'operations',
          question: "Katılamadığım dersi erteleyebilir miyim?",
          answer: "Evet. Katılamayacağınız dersi öğrenci ekranınızdan erteleyebilirsiniz."
        },
        {
          id: 17,
          category: 'general',
          question: "Gelişimimi nasıl takip edebilirim?",
          answer: "Öğrenci portalında hazırlıkları, öğretmen yorumlarını, ders notlarını ve performans değerlendirmelerini görebilirsiniz."
        },
        {
          id: 18,
          category: 'lessons',
          question: "İş İngilizcesi eğitimi var mı?",
          answer: "Evet. Programlar toplantı, sunum, e-posta, iş görüşmesi ve mesleki iletişim hedeflerine göre planlanır."
        },
        {
          id: 19,
          category: 'general',
          question: "Online İngilizce kursu fiyatları ne kadar?",
          answer: "Fiyatlar haftalık ders sıklığına ve seçilen programa göre değişir. Size özel seçenekler ücretsiz görüşme sonrasında paylaşılır."
        }
      ]
    }
  },
  computed: {
    filteredFaq() {
      if (this.searchQuery.trim()) {
        const query = this.searchQuery.toLocaleLowerCase('tr-TR').trim();
        return this.faqItems.filter(
          item =>
            item.question.toLocaleLowerCase('tr-TR').includes(query) ||
            item.answer.toLocaleLowerCase('tr-TR').includes(query)
        );
      }
      return this.faqItems.filter(item => item.category === this.activeCategory);
    }
  },
  methods: {
    selectCategory(catId) {
      this.activeCategory = catId;
      this.openQuestion = null;
      this.searchQuery = ''; // Kategoriye geçince aramayı temizle
    }
  }
}
</script>

<style scoped>
.faq-page { min-height: 75vh; padding: 56px 0 64px; background: #f7f9f7; color: #24382e; }
.faq-container { max-width: 1080px; }
.faq-header { max-width: 660px; margin: 0 auto 48px; text-align: center; }
.eyebrow { display: block; margin-bottom: 16px; color: var(--brand-link); font-size: .72rem; font-weight: 700; letter-spacing: .12em; }
.faq-header h1 { margin: 0 0 16px; font-size: clamp(1.9rem, 4vw, 2.8rem); font-weight: 700; letter-spacing: -.035em; line-height: 1.2; }
.faq-header > p { color: #637269; line-height: 1.7; }
.faq-search { display: flex; align-items: center; gap: 14px; max-width: 560px; margin: 28px auto 0; padding: 0 18px; border: 1px solid #d9e2da; border-radius: 14px; background: #fff; text-align: left; color: #637269; }
.faq-search:focus-within { border-color: var(--brand-primary); box-shadow: 0 0 0 3px rgba(79,183,72,.12); }
.faq-search input { min-width: 0; width: 100%; height: 56px; padding: 0; border: 0; outline: 0; background: transparent; color: #24382e; font: inherit; font-size: .92rem; }
.faq-search input::placeholder { color: #79857d; }
.faq-search input::-webkit-search-cancel-button { display: none; }
.faq-search button { flex-shrink: 0; width: 32px; height: 36px; padding: 0; border: 0; border-radius: 6px; background: transparent; color: #637269; }
.faq-header .search-hint { margin: 10px 0 0; font-size: .78rem; }
.faq-layout { display: grid; grid-template-columns: 250px minmax(0,1fr); align-items: start; gap: 40px; }
.category-label { margin: 0 0 14px 12px; font-size: .7rem; font-weight: 700; color: #637269; letter-spacing: .1em; }
.category-button { display: flex; align-items: center; gap: 12px; width: 100%; padding: 14px 12px; margin-bottom: 6px; border: 1px solid transparent; border-radius: 10px; background: transparent; color: #526359; text-align: left; font-size: .87rem; }
.category-button > i { font-size: 1.1rem; }
.category-button:hover { background: #eef3ee; }
.category-button.active { border-color: #dce9dc; background: #edf5eb; color: var(--brand-link); font-weight: 600; }
.category-count { margin-left: auto; font-size: .75rem; }
.results-header { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 18px; }
.results-header h2 { margin: 0; font-size: 1.15rem; font-weight: 600; letter-spacing: -.02em; }
.results-header > span { flex-shrink: 0; color: #637269; font-size: .8rem; }
.search-summary { margin: -4px 0 18px; color: #637269; font-size: .85rem; overflow-wrap: anywhere; }
.faq-list { overflow: hidden; border: 1px solid #e0e7e0; border-radius: 16px; background: #fff; }
.faq-item + .faq-item { border-top: 1px solid #e8ede8; }
.faq-item h3 { margin: 0; }
.faq-question { display: flex; align-items: center; justify-content: space-between; gap: 24px; width: 100%; padding: 24px; border: 0; background: transparent; color: #24382e; text-align: left; font-size: .95rem; font-weight: 600; line-height: 1.6; }
.faq-question > i { flex-shrink: 0; font-size: 1rem; }
.faq-question:hover { background: #f8faf7; }
.open .faq-question { color: var(--brand-link); }
.faq-answer { padding: 0 24px 24px; color: #637269; font-size: .9rem; line-height: 1.85; overflow-wrap: anywhere; }
.faq-answer :deep(strong) { color: #344d3d; font-weight: 600; }
.faq-answer :deep(ul) { padding-left: 22px; margin: 12px 0; }
.faq-answer :deep(li + li) { margin-top: 6px; }
.faq-empty { padding: 44px 24px; border: 1px solid #e0e7e0; border-radius: 16px; background: #fff; text-align: center; }
.faq-empty > i { display: block; margin-bottom: 20px; color: var(--brand-link); font-size: 1.5rem; }
.faq-empty h3 { font-size: 1.05rem; font-weight: 600; }
.faq-empty p, .faq-help { color: #637269; font-size: .8rem; line-height: 1.7; }
.faq-help { margin: 24px 0 0; }
.faq-empty button { padding: 11px 20px; border: 1px solid #dce9dc; border-radius: 10px; background: #edf5eb; color: var(--brand-link); font-size: .85rem; font-weight: 600; }
.faq-page button:focus-visible { outline: 2px solid var(--brand-link); outline-offset: -3px; }
@media (max-width: 767.98px) {
  .faq-page { padding: 32px 0 40px; }
  .faq-header { margin-bottom: 32px; }
  .faq-layout { grid-template-columns: 1fr; gap: 28px; }
  .faq-categories { display: flex; flex-wrap: wrap; gap: 8px; }
  .category-label { width: 100%; margin: 0 0 4px; }
  .category-button { width: auto; margin: 0; padding: 10px 12px; gap: 8px; border-color: #e0e7e0; background: #fff; font-size: .8rem; }
  .category-count { margin-left: 4px; }
  .faq-question { padding: 20px; gap: 16px; font-size: .9rem; }
  .faq-answer { padding: 0 20px 20px; }
}
</style>